module.exports = __webpack_public_path__ + "85504a4fa5d9ea14d59befa3a5b0c181.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/Foto_Manja_Herrmann-8352_klein.jpg
// module id = 459
// module chunks = 0